import React from 'react';
import styles from './SearchTopics.module.scss';
import { useNavigate } from 'react-router-dom';
import { Topic } from '../../../Models';
import { SearchTopic } from '../../../Components/SearchTopic/SearchTopic';

export interface SearchTopicsProps {
  topics: Topic[];
}

export const SearchTopics = ({
  topics
}: SearchTopicsProps): React.ReactElement<SearchTopicsProps> => {
  const navigate = useNavigate();
  const onSelect = (value: string) => navigate(`/topic/${value}`);

  return (
    <div className={styles.searchTopics}>
      <h2 className={styles.title}>Search for topics</h2>

      <div className={styles.searchWrapper}>
        <SearchTopic
          className={styles.search}
          topics={topics}
          onSelect={onSelect}
        />
      </div>
    </div>
  );
};
